import React, { Component } from "react";
import axios from "axios";
import * as api from "../../constants/api";
import { adalApiFetch } from "../../adalConfig";
import ReactTable from "react-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "react-table/react-table.css";
import DomainBlockMappingInfo from "../domainblockmapping/DomainBlockMappingInfo";
import Modal from 'react-modal';
import { toastSuccess, toastError, customStyles } from '../../util/CommonFunctions'
import NavMenu from '../NavMenu'

Modal.setAppElement('#root')

class DomainBlockMappingList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            defaultOption: { key: 0, value: "All" },
            DomainBlockMappings: [],
            LicenseTypes: [],
            ProductFamilies: [],
            DisplayedCount: 0,
            Count: 0,
            Take: 10,
            ShowFilters: true,
            OrgData: {
                Id: 0,
                LicenseTypeId: 0,
                ProductFamilyId: 0,
                IsActive: true,
            },
            Filter: [],
            IsLoaded: false,
            isDialogOpen: false,
            isEditDialogOpen: false,
            dataFilled: false
        };
    }    
    

    componentDidMount() {
        this.getLookups();
        this.getInitial();
    }

    componentDidUpdate() {
        if (this.state.OrgData.LicenseTypeId !== 0 && this.state.OrgData.ProductFamilyId !== 0) {
            if (this.state.dataFilled === false) {
                this.setState({ dataFilled: true });
            }
        }
        else {
            if (this.state.dataFilled === true) {
                this.setState({ dataFilled: false });
            }
        }
    }

    handleLicenseTypeChange = e => {
        const val = e.target.value;
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.LicenseTypeId = parseInt(val);
        this.setState({ OrgData: orgData });
    };

    handleProductFamilyChange = e => {
        const val = e.target.value;
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.ProductFamilyId = parseInt(val);
        this.setState({ OrgData: orgData });
    };

    handleIsActiveChange = e => {
        const val = e.target.checked;
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.IsActive = val;
        this.setState({ OrgData: orgData });
    };

    openDialog(id) {
        this.setState({ isDialogOpen: true })
        this.setState({ rowID: id })
    }

    handleClose = () => this.setState({ isDialogOpen: false, isEditDialogOpen: false })


    render() {
        const {
            DomainBlockMappings: data,
            IsLoaded
        } = this.state;

        const { canCreateRWAMapping, canViewRWAMapping } = this.props;

        const columns = [
            {
                Header: "ID",
                accessor: "id",
                maxWidth: 80
            },
            {
                Header: "License Type",
                accessor: "licenseType",
                filterMethod: this.defaultFilter
            },
            {
                Header: "Product Family",
                accessor: "productFamily",
                filterMethod: this.defaultFilter
            },
            {
                Header: "Is Active",
                accessor: "isActive",
                maxWidth: 100,
                Cell: props => {
                    return (
                        <span>{props.value ? "Yes" : "No"}</span>
                    );
                },
                filterMethod: (filter, row) => {
                    if (filter.value === "all") return true;
                    if (filter.value === "true") return row[filter.id] === true;
                    if (filter.value === "false") return row[filter.id] === false;
                    return true;
                },
                Filter: ({ filter, onChange }) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : "all"}
                    >
                        <option value="all">All</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
            },
            {
                Header: "Edit",
                style: { flex: "1" },
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                filterable: false,
                sortable: false,
                Cell: props => {
                    return (
                        <div>
                            {canCreateRWAMapping && (
                                <div>
                                    <button className="btn small"
                                    onClick={() => {
                                        let selRow = props.row._original;
                                        this.handleClickEdit(selRow);
                                    }} >
                                    <FontAwesomeIcon icon="edit" color="Grey" />
                                </button>
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                Header: "Delete",
                style: { flex: "1" },
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                filterable: false,
                sortable: false,
                Cell: props => {
                    return (
                        <div>
                            {canCreateRWAMapping && (
                                <div>
                                    <button className="btn small"
                                        onClick={() => { this.openDialog(props.row._original.id); }} >
                                        <FontAwesomeIcon icon="trash" color="Grey" />
                                    </button>
                                    <Modal isOpen={this.state.isDialogOpen} style={customStyles} overlayClassName="Overlay" >
                                        <div>
                                            <div className="modalDivHeader">
                                            </div>
                                            <div className="details-section-header modalLabel">
                                                <label className="modalLabel">  Delete Domain Block Mapping </label>
                                                <button id="btnClose" onClick={this.handleClose}>  X  </button>
                                            </div>
                                            <h4 className="lblNVGreen">Are you sure you want to delete record {this.state.rowID} ?</h4>
                                            <center>
                                                <button className="btn" onClick={() => this.handleClickDelete(this.state.rowID)}> Yes </button>
                                            </center>
                                        </div>
                                    </Modal>
                                </div>
                            )}
                        </div>
                    );
                }
            },
        ];

        if (!IsLoaded) {
            return (
                <div className="loading-full">
                    <FontAwesomeIcon
                        icon="spinner"
                        spin
                        className="color-nvgreen"
                        size="2x"
                    />
                    <div className="loading-text">loading page content</div>
                </div>
            );
        }

        return (
            <div>
                {canViewRWAMapping && (
                    <NavMenu />
                )}
                {canCreateRWAMapping && (
                    <div className="flex-fill">
                        <div className="divAddBtn">
                            <button className="btn" id="btnAdd" onClick={() => { this.handleClickEdit() }} >
                                <FontAwesomeIcon icon="plus" />
                            </button>
                        </div>
                    </div>
                )}
                <div className="content" >
                    <h4 className="lblNVGreen"> Domain Block Mappings </h4>

                    {canViewRWAMapping && (
                        <div>
                            <ReactTable
                            data={data}
                            columns={columns}
                            defaultPageSize={this.state.Take}
                            minRows={0}
                            filterable={this.state.ShowFilters}
                            resizable={false}
                            className="-striped -highlight"
                            filtered={this.state.Filter}
                            onFilteredChange={filtered => {
                                this.setState({ Filter: filtered });
                            }}
                        >
                            {(state, makeTable, instance) => {
                                let recordsInfoText = "";

                                const { filtered, pageRows, pageSize, sortedData, page } = state;

                                if (sortedData && sortedData.length > 0) {
                                    let isFiltered = filtered.length > 0;
                                    let totalRecords = sortedData.length;
                                    let recordsCountFrom = page * pageSize + 1;
                                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                                    if (isFiltered)
                                        recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
                                    else
                                        recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
                                } else recordsInfoText = "No records";

                                const dashboard = (
                                    <div className="dashboard">
                                        <div className="dashboard-text">{recordsInfoText}</div>
                                    </div>
                                );
                                return (
                                    <div>
                                        {dashboard}
                                        {makeTable()}
                                    </div>
                                );
                            }}
                        </ReactTable>
                            <div id="divTbl"> </div>
                        </div>
                    )}
                 </div>

                <Modal isOpen={this.state.isEditDialogOpen} style={customStyles} overlayClassName="Overlay">
                    <div>
                        <div className="modalDivHeader">
                        </div>
                        <div className="details-section-header modalLabel">
                            <label className="modLabel"> Domain Block Mapping Maintenance </label>
                            <button id="btnClose" onClick={this.handleClose}>  X  </button>
                        </div>
                        <DomainBlockMappingInfo
                            orgData={this.state.OrgData}
                            licenseTypes={this.state.LicenseTypes}
                            productFamilies={this.state.ProductFamilies}
                            handleLicenseTypeChange={this.handleLicenseTypeChange}
                            handleProductFamilyChange={this.handleProductFamilyChange}
                            handleIsActiveChange={this.handleIsActiveChange}
                            dataFilled={this.state.dataFilled}
                            onSaveClick={this.handleSaveClick} />
                    </div>
                </Modal>
            </div>
        );
    }
    handleSaveClick = e => {
        let orgData = Object.assign({}, this.state.OrgData);
        let id = parseInt(orgData.Id) ? parseInt(orgData.Id) : 0;

        let data = {
            Id: id,
            LicenseType: this.getLicenseTypeName(orgData.LicenseTypeId),
            ProductFamily: this.getProductFamilyName(orgData.ProductFamilyId),
            IsActive: orgData.IsActive
        };

        if (orgData.LicenseTypeId === 0) {
            toastError("License Type is Required");
            return false;
        }

        if (orgData.ProductFamilyId === 0) {
            toastError("Product Family is Required");
            return false;
        }

        adalApiFetch(
            axios,
            api.POST_CREATE_DOMAIN_BLOCKING_ELIGIBILITY,
            {
                method: "post",
                data: data,
            }
        )
        .then(response => {
            console.log(response);
            this.getInitial();
            this.resetElements();
            toastSuccess(response.data["Data"] || "Domain Block Mapping saved successfully");
      })
        .catch(error => {
            console.log(error);
            if (error.response) {
                if (error.response.data.title)
                    toastError(JSON.stringify(error.response.data["errors"]));
                else
                    toastError(error.response.data["Message"]);
            }
        });
    }

    getLicenseTypeName(id) {
        const licenseType = this.state.LicenseTypes.find(lt => lt.key === id);
        return licenseType ? licenseType.value : "";
    }

    getProductFamilyName(id) {
        const productFamily = this.state.ProductFamilies.find(pf => pf.key === id);
        return productFamily ? productFamily.value : "";
    }

    getLicenseTypeId(name) {
        const licenseType = this.state.LicenseTypes.find(lt => lt.value === name);
        return licenseType ? licenseType.key : 0;
    }

    getProductFamilyId(name) {
        const productFamily = this.state.ProductFamilies.find(pf => pf.value === name);
        return productFamily ? productFamily.key : 0;
    }

    resetElements = e => {
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.Id = 0;
        orgData.LicenseTypeId = 0;
        orgData.ProductFamilyId = 0;
        orgData.IsActive = true;
        this.setState({ OrgData: orgData, isDialogOpen: false, isEditDialogOpen: false }, function () { });
    }

    handleClickEdit(selRow) {
        console.log(selRow);
        this.setState({ isEditDialogOpen: true })
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.Id = selRow ? selRow.id : 0;
        orgData.LicenseTypeId = selRow ? this.getLicenseTypeId(selRow.licenseType) : 0;
        orgData.ProductFamilyId = selRow ? this.getProductFamilyId(selRow.productFamily) : 0;
        orgData.IsActive = selRow ? selRow.isActive : true;
        this.setState({ OrgData: orgData, isEditDialogOpen: true }, function () {
            console.log(this.state.OrgData);
        });
    }

    handleClickDelete(id) {
        adalApiFetch(
            axios,
            api.DELETE_DOMAIN_BLOCKING_ELIGIBILITY + '/' + parseInt(id),
            {
                method: "delete",
            }
        )
        .then(res => {
            console.log(res.data);
            this.handleClose();
            this.getInitial();
            toastSuccess(res.data["Data"] || "Domain Block Mapping deleted successfully");
       })
        .catch(error => {
            console.log(error);
            if (error.response) {
                console.log(error.response);
                toastError(error.response.data["Message"]);
            }
        });
    }

    defaultFilter(filter, row, column) {
        return (
            row[filter.id] &&
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
        );
    }

    getInitial() {
        adalApiFetch(axios, api.GET_DOMAIN_BLOCKING_ELIGIBILITY, {})
            .then(response => {
                const modifiedData = response.data.map(r => {
                    return r;
                });

                this.setState({
                    IsLoaded: true,
                    DomainBlockMappings: modifiedData,
                    Count: response.data.totalCount,
                    DisplayedCount: this.state.Take,
                    GetMoreEnabled: true
                });
            })
            .catch(error => {
                console.log(error.response);
            });
    }

    getLookups() {
        adalApiFetch(axios, api.GET_RWA_LOOKUPS, {})
            .then(response => {
                let licenseTypes = response.data.LicenseType ? [...response.data.LicenseType] : [];
                let productFamilies = response.data.ProductFamily ? [...response.data.ProductFamily] : [];
                
                licenseTypes.unshift(this.state.defaultOption);
                productFamilies.unshift(this.state.defaultOption);

                this.setState({
                    LicenseTypes: licenseTypes,
                    ProductFamilies: productFamilies,
                });
            })
            .catch(error => {
                console.log(error);
                if (error.response) {
                    console.log(error.response);
                }
            });
    }
}

export default DomainBlockMappingList;

